import React from 'react';

import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { history } from './history';

import * as Pages from 'pages';

import { AuthRoute, PrivateRoute, JourneyRoute } from './components';

const Routes = () => (
  <Router history={history}>
    <Switch>
      <AuthRoute path="/login" component={Pages.Auth.Login} exact />
      {/* <AuthRoute path="/register" component={Pages.Auth.Register} exact />*/}
      <AuthRoute path="/recover-password" component={Pages.Auth.RecoverPassword} exact />

      {/* Require authentication to access */}
      <PrivateRoute path="/" component={() => <Redirect to="/admin/interviews" />} exact />
      <PrivateRoute path="/admin" component={() => <Redirect to="/admin/interviews" />} exact />

      {/* Participants */}
      <PrivateRoute path="/admin/dashboard" component={Pages.Admin.Dashboard} exact />
      <PrivateRoute path="/admin/participants" component={Pages.Admin.Participants.List} exact />
      <PrivateRoute path="/admin/participants/create" component={Pages.Admin.Participants.Create} exact />
      <PrivateRoute path="/admin/participants/:id/edit" component={Pages.Admin.Participants.Edit} exact />

      {/* Interviews */}
      <PrivateRoute path="/admin/interviews" component={Pages.Admin.Interviews.List} exact />
      <PrivateRoute path="/admin/interviews/create" component={Pages.Admin.Interviews.Create} exact />
      <PrivateRoute path="/admin/interviews/:id/edit" component={Pages.Admin.Interviews.Edit} exact />
      <PrivateRoute path="/admin/interviews/bulk" component={Pages.Admin.Interviews.Bulk} exact />

      {/* Journeys */}
      <PrivateRoute path="/admin/journeys" component={Pages.Admin.Journeys.List} exact />
      <PrivateRoute path="/admin/journeys/create" component={Pages.Admin.Journeys.Create} exact />
      <PrivateRoute path="/admin/journeys/:id/edit" component={Pages.Admin.Journeys.Edit} exact />

      <PrivateRoute path="/admin/report" component={Pages.Admin.Report} exact />

      {/* MagicLink */}
      <Route path="/magiclink/:id" component={Pages.MagicLink} exact />

      {/* Journey */}
      <JourneyRoute path="/journey/:id/east" component={Pages.Journey.East} exact />
      <JourneyRoute path="/journey/:id/north" component={Pages.Journey.North} exact />
      <JourneyRoute path="/journey/:id/south" component={Pages.Journey.South} exact />
      <JourneyRoute path="/journey/:id/west" component={Pages.Journey.West} exact />
      <JourneyRoute path="/journey/:id/complete" component={Pages.Journey.Complete} exact />

      <Route component={Pages.Errors.Maintanence} />
      <Route component={Pages.Errors.NotFound} />
    </Switch>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js